import { Directive, ElementRef, Input, OnInit, Renderer2 } from "@angular/core";
import { PermissionsEnum } from "../../constants/settings.enum";
import { PermissionsService } from "./permissions.service";
@Directive({
    selector: '[disabledByPermission]'
})
export class DisabledByPermissionDirective implements OnInit {
    @Input() disabledByPermission: PermissionsEnum | boolean = PermissionsEnum.Perm_WF_IncomeTax;
    constructor(
        private el: ElementRef,
        private render: Renderer2, private permissionService: PermissionsService) {
    }

    ngOnInit(): void {
        var isDisabled = true;
        var isEnabled = false;
        let statusForControl: any;
        if(typeof this.disabledByPermission !== "boolean"){
            var permission = this.permissionService.GetPermission(this.disabledByPermission);
            statusForControl = (permission && !permission.valueAsBoolean) ? isDisabled : isEnabled;
        } else {
            statusForControl = isDisabled;
        }
        //  A ENABLED permission is a permission that ALLOWS (enabled) the setting
        // by only ENABLING disabled, it means we can double up with the 'normal' disabled without overwriting it with this.
        if (isDisabled) {
            this.render.setProperty(
                this.el.nativeElement,
                'disabled',
                statusForControl
            );
        }
    }
}